import src from "IMAGE";
export default { src, width: 800, height: 800, blurWidth: 0, blurHeight: 0};
